import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { Tv3PlatformModule } from '@tokeet-frontend/tv3-platform'
import { AttributeDescriptionStoreModule } from './store/attr-desc/module'
import { EntityAttributesConfigOverlayComponent } from './components/entity-attributes-config-overlay/entity-attributes-config-overlay.component'
import { EntityAttributesOverlayComponent } from './components/entity-attributes-overlay/entity-attributes-overlay.component'
import { EntityAttributesConfigOverlayService } from './components/entity-attributes-config-overlay/entity-attributes-config-overlay.service'
import { EntityAttributesComponent } from './components/entity-attributes/entity-attributes.component'
import { EntityAttributesService } from './store/attrs'
import { EntityAttributeStoreModule } from './store/attrs/module'

const components = [
  //
  EntityAttributesComponent,
  EntityAttributesConfigOverlayComponent,
  EntityAttributesOverlayComponent,
]

const services = [
  //
  EntityAttributesConfigOverlayService,
  EntityAttributesService,
]

const modules = [
  //
  Tv3PlatformModule,
  AttributeDescriptionStoreModule,
  EntityAttributeStoreModule,
]

@NgModule({
  imports: [CommonModule, ...modules],
  exports: [components, ...modules],
  declarations: [
    //
    ...components,
  ],

  providers: [
    //
    ...services,
  ],
})
export class CustomAttrsLibraryModule {}
